import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineManufacturer";

const url = "/api/machines/MachineManufacturer";

export const machineManufacturerLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Manufacturer",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
